import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button } from '../../../../../Common/Button'
import { Flex } from '../../../../../Common/Flex'

export const CalendarIcon = styled(FontAwesomeIcon)`
  color: #000000;
  margin: 0 8px;
`

export const CalendarContainer = styled(Flex)``
export const CalendarIconContainer = styled(Flex)``

export const CalendarIconTime = styled.time`
  font-size: 1em;
  display: block;
  position: relative;
  width: 4.5em;
  height: 4.5em;
  background-color: #fff;
  border-radius: 0.6em;
  box-shadow: rgba(44, 47, 60, 0.2) 0 6px 15px;
  overflow: hidden;
  transform-origin: 50% 10%;
`

export const IconText = styled.div`
  display: flex;
  width: 100%;
  font-size: 1em;
  font-weight: bold;
  font-style: normal;
  text-align: center;
  padding: 14px;
  align-items: center;
  margin: 1em 0;
  justify-content: center;
`

export const IconStrong = styled.strong`
  position: absolute;
  top: 0;
  padding: 6px;
  color: #fff;
  background-color: #df6158;
  box-shadow: 0 2px 0 #df6158;
  width: 100%;
  text-align: center;
`

export const IconEm = styled.em`
  position: absolute;
  bottom: 0.3em;
  font-size: 0.75em;
  color: #000000;
`

export const IconSpan = styled.span`
  width: 100%;
  font-size: 1.85em;
  letter-spacing: -0.05em;
  padding-top: -2.2em;
  color: #2f2f2f;
`

export const Overlay = styled.div`
  background-color: rgba(210, 68, 68, 0.92) !important;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  position: absolute;
  left: 0;
  top: 0;
`

export const RemoveButtonIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`

export const StyledButton = styled(Button)`
  width: 105px;
  color: #005cdb;
  border: 3px solid #005cdb;
  margin: 0 8px;
  &:hover {
    color: #fff;
    background: #005cdb;
    cursor: pointer;
    border: 3px solid #005cdb;
  }
`
